import { Component, OnInit } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';

import { ContractOverviewComponent } from './components/contract-overview/contract-overview.component';
import { loadContractsRequest } from './store/contract.actions';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  imports: [ContractOverviewComponent],
})
export class ContractComponent implements OnInit {
  constructor(private readonly store: Store<RootState>) {}

  ngOnInit() {
    this.store.dispatch(loadContractsRequest());
  }
}
